var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFigmaEyeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10 15.556a8.07 8.07 0 0 0 4.334-1.23l-1.943-1.94A3.417 3.417 0 0 1 7.61 7.613l-1.942-1.94q-2.235 1.383-4 4.328Q5 15.556 10 15.556ZM9.948 6.246 8.315 4.61A8.4 8.4 0 0 1 10 4.444q5 0 8.333 5.556-.925 1.542-1.98 2.657l-2.6-2.603q.025-.206.025-.417a3.418 3.418 0 0 0-3.83-3.391Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m2.5 2.5 15 15m-3.166-3.173A8.07 8.07 0 0 1 10 15.556q-5 0-8.333-5.556 1.765-2.945 4-4.328l1.942 1.94a3.418 3.418 0 0 0 4.782 4.775zM9.948 6.246 8.315 4.61A8.4 8.4 0 0 1 10 4.444q5 0 8.333 5.556-.925 1.542-1.98 2.657l-2.6-2.603q.025-.206.025-.417a3.418 3.418 0 0 0-3.83-3.391"
})));
export default SvgFigmaEyeOff;